// ImageTamperingDetection.
import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import { Grid, Stack } from "@mui/material";
import FileDragDrop from "../components/Common/FileDragDrop";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CustomButton from "../components/Common/CustomButton";
import FilePreview from "../components/pages/FaceMatch/FilePreview";
import HeaderTop from "../components/pages/OCR/HeaderTop";
import JSONCard from "../components/Common/JSONCard";
import ImagePreview from "../components/pages/FaceMatch/ImagePreview"; // Changed from VideoPreview
import {
  imageDetectionPost,
  pullResultGet,
} from "../service/apiActions/ImageDetection"; // Changed API imports
import Loader from "../components/Common/Loader/Loader";
import { Files } from "@aws-amplify/ui-react/dist/types/components/Storage/FileUploader/types";

const ImageTamperingDetection = () => {
  const { handleChangeTitle } = useOutletContext<{
    handleChangeTitle: (title: string, subTitle: string) => void;
  }>();
  const [file, setFile] = useState<any>({});
  const [isLoading, setLoading] = useState(false);
  const [result, setResult] = useState<any>({});
  const [preview, setPreview] = useState<string | null>(null);
  const [disable, setDisable] = useState<boolean>(false);

  useEffect(() => {
    handleChangeTitle(
      "Image Tampering Detection",
      "Analyze and moderate image content for advertisements" // Updated subtitle
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reset = () => {
    setFile({});
    setResult({});
  };

  const handleFileChange = (files: Files) => {
    if (files && files.length > 0) {
      const selectedFile = files[0];
      // Add image file type validation
      if (selectedFile && selectedFile.type.startsWith("image/")) {
        setFile(selectedFile);
      } else {
        alert("Please select a valid image file");
      }
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    setDisable(true);
    if (file) {
      const url = URL.createObjectURL(file); // ✅ create temporary URL
      setPreview(url);
    }
    try {
      const formData = new FormData();
      formData.append("image", file); // ✅ use "image" instead of "file"
      formData.append("title", "image");

      for (const [key, value] of formData.entries()) {
        console.log(key, value);
      }

      const response: any = await imageDetectionPost(formData);

      if (response && response?.id) {
        setDisable(false);
        setLoading(true);
        pollForResult(response.id);
      }
    } catch (error) {
      console.error("Upload failed:", error);
    }
  };

  const pollForResult = (id: string) => {
    const interval = setInterval(async () => {
      try {
        const res: any = await pullResultGet(id); // Changed to image API

        console.log("Polling response:", res);

        if (res?.status === "Processed") {
          setResult(res);
          setLoading(false);
          clearInterval(interval); // ✅ stop polling when ready
        }
      } catch (error) {
        console.log("Still processing...");
      }
    }, 1000); // every 5 seconds
  };

  console.log("result", result);

  if (isLoading) {
    return <Loader />;
  }

  return Object.keys(result).length > 0 ? (
    <>
      <HeaderTop reset={reset} />
      <Grid container mt={0} spacing={2}>
        <Grid item lg={6} md={5} sm={6} xs={12}>
          <ImagePreview
            title="Image Preview"
            src={preview ? preview : ""} // Image source from result
            // name="image.jpg"
            maxheight="100%" 
            sx = {{
              overflowY:"scroll",
               maxHeight : "460px",
               
                     "&::-webkit-scrollbar": {
                     width: "2px",
                     marginRight:"8px",
                        // opacity: "0",
                        // animation: `${animatedBackground} 5s linear `,
                    },
                    "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#9F9FA1",
                        borderRadius: "8px",
                        // height: "50px",
                    },
                    "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f0f0f0",
                        opacity: "0.5",
                        borderRadius: "8px",
                        height: "5px",
                    },
            }}
            // Changed filename for image
          />
        </Grid>

        <Grid item lg={6} md={5} sm={6} xs={12}>
          <JSONCard data={result} />
        </Grid>
      </Grid>
    </>
  ) : (
    <Grid container spacing={2}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        {file?.name ? (
          <FilePreview
            sx={{ mt: 1 }}
            name={file?.name}
            filesize={file?.size}
            handleClose={() => setFile({})}
          />
        ) : (
          <FileDragDrop
            handleChange={handleFileChange}
            // acceptedTypes="image/*" // Changed to accept only images
            // type=" *jpg, jpeg, png, gif, bmp only" // Updated accepted file types
            // placeholder="Drop your image here or click to browse" // Updated placeholder
          />
        )}
      </Grid>
      <Grid item xs={12}>
        <Stack direction="row" gap={1.5}>
          <CustomButton
            startIcon={<FileUploadOutlinedIcon />}
            size="large"
            onClick={handleUpload}
            disabled={!file?.name || disable} // Disable if no files selected
            sx={{
              border: !file?.name ||  disable ? "none" : "1px solid",
            }}
          >
            Upload
          </CustomButton>
          <CustomButton
            variant="outlined"
            size="large"
            startIcon={<RefreshOutlinedIcon />}
            onClick={reset}
           
          >
            Reset
          </CustomButton>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default ImageTamperingDetection;
